import axiosClient from './axiosClient';

/** Support chat REST surface (history + the admin inbox). Live messages go over STOMP. */
const chatService = {
  history: (conversationId) =>
    axiosClient.get('/chat/messages', { params: { conversationId } }),

  // REST fallback if the socket is down
  send: (message) => axiosClient.post('/chat/messages', message),

  // admin / approver
  conversations: () => axiosClient.get('/chat/conversations'),
  conversation: (conversationId) => axiosClient.get(`/chat/conversations/${conversationId}`),
  unreadCount: () => axiosClient.get('/chat/unread-count'),
};

export default chatService;
